import MenteeSignupForm from "./MenteeSignupForm";
import InfoPanel from "../components/RightPannel";
import MentorSignUpForm from "./MentorSignUpForm";
const Signup = () => {
  const type = localStorage.getItem("userType");
  return (
    <InfoPanel parent="signup">
      {type === "mentor" ? <MentorSignUpForm /> : <MenteeSignupForm />}
    </InfoPanel>
  );
};

export default Signup;
